import React, { useState, useEffect } from 'react';
import '../styles/EcoReport.css';
import placeholderImg from '../assets/pixel-art/seeding.png';
import gardenService from '../services/gardenService';
import { fetchWikipediaImage } from '../utils/wikiImageFetcher';
import EarthLoader from '../components/EarthLoader';
import ecoReportCacheService from '../services/ecoReportCacheService';
import VirtualBook from '../components/EcoReport/VirtualBook.jsx'

const GardenEcoReport = () => {


  // const [plants, setPlants] = useState([]);
  // const [isLoading, setIsLoading] = useState(true);
  // const [error, setError] = useState(null);
  // const [currentSection, setCurrentSection] = useState(0);
  // const [milestones, setMilestones] = useState([]);
  // const [wildlifeSpotlight, setWildlifeSpotlight] = useState([]);
  // const [environmentalTips, setEnvironmentalTips] = useState([]);

  // // SUNFLOWER THEME PALETTE FOR JS
  // const THEME = {
  //   yellow: "#f4d03f",
  //   gold: "#d4ac0d",
  //   brown: "#5d4037",
  //   green: "#27ae60",
  //   blue: "#2980b9",
  //   purple: "#8e44ad"
  // };

  // // API base URL - update this to your actual backend URL
  // const API_BASE_URL = 'https://your-garden-guru-backend.vercel.app/api';

  // // Calculate milestone data based on plants
  // const calculateMilestones = (plantData) => {
  //   if (!plantData || plantData.length === 0) {
  //     return [];
  //   }

  //   // Calculate total carbon absorption
  //   const totalCarbon = plantData.reduce((total, plant) => {
  //     const carbonImpact = plant.ecoData?.carbon_kg_per_year_stage || 0;
  //     return total + parseFloat(carbonImpact);
  //   }, 0);

  //   // Calculate unique pollinators
  //   const uniquePollinatorValues = new Set();
  //   plantData.forEach(plant => {
  //     if (plant.ecoData?.pollinator_value && plant.ecoData.pollinator_value !== "None") {
  //       uniquePollinatorValues.add(plant.ecoData.pollinator_value);
  //     }
  //   });
  //   const pollinatorCount = uniquePollinatorValues.size;

  //   // Calculate number of plants providing shelter
  //   const shelterCount = plantData.filter(plant =>
  //     plant.ecoData?.provides_shelter === true
  //   ).length;

  //   return [
  //     {
  //       id: 1,
  //       title: "Carbon Milestone",
  //       description: `Your garden has absorbed approximately ${totalCarbon.toFixed(2)} kg of CO₂!`,
  //       icon: "🌿",
  //       achieved: totalCarbon > 0,
  //       date: new Date().toLocaleDateString('en-AU', { month: 'long', day: 'numeric', year: 'numeric' }),
  //       color: "rgb(73, 108, 28)",
  //       visualImpact: {
  //         value: totalCarbon.toFixed(2),
  //         unit: "kg CO₂",
  //         comparisons: [
  //           { icon: "🚗", text: `${(totalCarbon / 0.2236).toFixed(1)} km(s) car trip offset` },
  //           { icon: "💡", text: `${Math.round(totalCarbon * 6.67)} hours of LED light bulb use` }
  //         ]
  //       }
  //     },
  //     {
  //       id: 2,
  //       title: "Pollinator Paradise",
  //       description: `Your garden attracts ${pollinatorCount} different pollinator type(s)!`,
  //       icon: "🐝",
  //       achieved: pollinatorCount > 0,
  //       date: new Date().toLocaleDateString('en-AU', { month: 'long', day: 'numeric', year: 'numeric' }),
  //       color: "rgb(255, 193, 7)",
  //       visualImpact: {
  //         value: pollinatorCount,
  //         unit: "pollinator type(s)",
  //         comparisons: [
  //           { icon: "🌸", text: "Bees, butterflies, and other beneficial insects" },
  //           { icon: "🌻", text: "Supporting biodiversity in your area" }
  //         ]
  //       }
  //     },
  //     {
  //       id: 3,
  //       title: "Wildlife Shelter Champion",
  //       description: `${shelterCount} plants in your garden provide shelter for wildlife!`,
  //       icon: "🏡",
  //       achieved: shelterCount > 0,
  //       date: new Date().toLocaleDateString('en-AU', { month: 'long', day: 'numeric', year: 'numeric' }),
  //       color: "rgb(46, 125, 50)",
  //       visualImpact: {
  //         value: shelterCount,
  //         unit: "shelter plant(s)",
  //         comparisons: [
  //           { icon: "🐦", text: "Providing homes for birds" },
  //           { icon: "🐛", text: "Safe spaces for beneficial insects" }
  //         ]
  //       }
  //     }
  //   ];
  // };

  // const calculateTotalCarbon = () => {
  //   return plants.reduce((total, plant) => {
  //     const carbonImpact = plant.ecoData?.carbon_kg_per_year_stage || 0;
  //     return total + parseFloat(carbonImpact);
  //   }, 0).toFixed(2);
  // };

  // const generateWildlifeSpotlight = (plantData) => {
  //   const spotlightData = [];

  //   plantData.forEach(plant => {
  //     const ecoData = plant.ecoData;

  //     if (!ecoData) return;

  //     if (ecoData.pollinator_value && ecoData.pollinator_value !== "None") {
  //       const pollinatorName = ecoData.pollinator_value;
  //       const existingSpotlight = spotlightData.find(s => s.title === pollinatorName);

  //       if (!existingSpotlight) {
  //         const commonPollinators = {
  //           "Bees": { icon: "🐝", scientificName: "Apidae family", description: "Vital pollinators for gardens", behaviors: "Visits flowers for nectar and pollen", encouragementTip: "Plant native flowers to attract them" },
  //           "Butterflies": { icon: "🦋", scientificName: "Lepidoptera order", description: "Beautiful garden visitors", behaviors: "Feeds on nectar from flowers", encouragementTip: "Provide host plants for caterpillars" },
  //           "Hummingbirds": { icon: "🐦", scientificName: "Trochilidae family", description: "Agile nectar feeders", behaviors: "Hovers while feeding from flowers", encouragementTip: "Plant tubular red flowers" },
  //           "Moths": { icon: "🦋", scientificName: "Lepidoptera order", description: "Nocturnal pollinators", behaviors: "Active at dusk and night", encouragementTip: "Plant night-blooming flowers" }
  //         };

  //         const pollinatorInfo = commonPollinators[pollinatorName] || {
  //           icon: "🐝",
  //           scientificName: "Various species",
  //           description: "Important garden pollinator",
  //           behaviors: "Visits flowers for nectar",
  //           encouragementTip: "Plant a variety of flowering plants"
  //         };

  //         spotlightData.push({
  //           ...pollinatorInfo,
  //           title: pollinatorName,
  //           image: placeholderImg,
  //           wikiPageUrl: null
  //         });
  //       }
  //     }
  //   });

  //   return spotlightData.slice(0, 3);
  // };

  // const generateEnvironmentalTips = (plantData) => {
  //   return [
  //     {
  //       id: 1,
  //       tip: "Introduce Companion Plants to Attract Pollinators",
  //       reason: "Many pollinators, including bees and butterflies, are attracted to specific plant species like marigolds, lavender, and borage. These flowers attract beneficial insects that can help pollinate your cabbage or other crops while also supporting the local ecosystem.",
  //       implementation: "Plant marigolds or borage near your cabbage. These flowers attract bees and other pollinators, improving pollinator activity and supporting a healthier ecosystem, boosting fruit and vegetable yields in your garden and beyond.",
  //       ecologicalBenefit: "Increased pollinator activity supports overall garden biodiversity."
  //     },
  //     {
  //       id: 2,
  //       tip: "Implement a Water-Wise Watering System",
  //       reason: "Overwatering is a crucial issue in Melbourne's climate, leading to waste and unhealthy plant growth. Reduce waste and improve plant health with targeted watering.",
  //       implementation: "Install a drip irrigation system or use soaker hoses to deliver water directly to the roots of your cabbage plants, minimizing evaporation. Conserving water reduces strain on local resources and minimizes the energy required for water treatment and distribution.",
  //       ecologicalBenefit: "Conserving water reduces strain on water resources."
  //     },
  //     {
  //       id: 3,
  //       tip: "Start Composting Kitchen and Garden Waste",
  //       reason: "Composting reduces landfill waste and creates nutrient-rich soil amendment for your cabbage and other plants.",
  //       implementation: "Set up a compost bin or worm farm and add kitchen scraps and garden waste. Use the compost to enrich the soil around your cabbage.",
  //       ecologicalBenefit: "Composting reduces methane emissions from landfills, improves soil health, and reduces the need for synthetic fertilizers."
  //     },
  //     {
  //       id: 4,
  //       tip: "Mulch Around Your Cabbage Plants",
  //       reason: "Mulching helps retain soil moisture, suppress weeds, and regulate soil temperature, benefiting your cabbage plants.",
  //       implementation: "Apply a layer of organic mulch, such as straw or wood chips, around your cabbage plants, keeping it away from the stems.",
  //       ecologicalBenefit: "Mulching reduces water consumption, suppresses weeds (reducing the need for herbicides), and improves soil health by fostering beneficial microorganisms."
  //     },
  //     {
  //       id: 5,
  //       tip: "Plant a Native Flowering Shrub Nearby",
  //       reason: "Native plants support local bird species, butterflies, and beneficial insects. A flowering shrub adds beauty while attracting wildlife.",
  //       implementation: "Choose a native shrub suited to your area (e.g., Grevillea, Banksia) and plant it near your garden.",
  //       ecologicalBenefit: "Native plants require less water and support local wildlife, contributing to biodiversity conservation."
  //     }
  //   ];
  // };

  // const handleImageError = (spotlight) => (e) => {
  //   console.warn(`Image failed to load for ${spotlight.title}, using placeholder`);
  //   e.target.src = placeholderImg;
  // };

  // useEffect(() => {
  //   const loadReportData = async () => {
  //     try {
  //       setIsLoading(true);
  //       setError(null);

  //       const cachedData = ecoReportCacheService.getCachedReport();

  //       if (cachedData) {
  //         console.log('Using cached eco report data');
  //         setPlants(cachedData.plants || []);
  //         setMilestones(cachedData.milestones || []);
  //         setWildlifeSpotlight(cachedData.wildlife || []);
  //         setEnvironmentalTips(cachedData.tips || []);
  //         setIsLoading(false);
  //         return;
  //       }

  //       const gardenData = await gardenService.getUserGarden();

  //       if (!gardenData || gardenData.length === 0) {
  //         setPlants([]);
  //         setIsLoading(false);
  //         return;
  //       }

  //       const plantsWithEcoData = gardenData.map(plant => ({
  //         ...plant,
  //         ecoData: plant.eco_data || null
  //       }));

  //       setPlants(plantsWithEcoData);

  //       const calculatedMilestones = calculateMilestones(plantsWithEcoData);
  //       setMilestones(calculatedMilestones);

  //       const wildlifeData = generateWildlifeSpotlight(plantsWithEcoData);
  //       setWildlifeSpotlight(wildlifeData);

  //       const tipsData = generateEnvironmentalTips(plantsWithEcoData);
  //       setEnvironmentalTips(tipsData);

  //       const enrichedWildlife = await Promise.all(
  //         wildlifeData.map(async (spotlight) => {
  //           try {
  //             const wikiData = await fetchWikipediaImage(spotlight.title);
  //             return {
  //               ...spotlight,
  //               image: wikiData.imageUrl || placeholderImg,
  //               wikiPageUrl: wikiData.pageUrl || null
  //             };
  //           } catch (error) {
  //             console.error(`Failed to fetch Wikipedia data for ${spotlight.title}:`, error);
  //             return spotlight;
  //           }
  //         })
  //       );

  //       setWildlifeSpotlight(enrichedWildlife);

  //       ecoReportCacheService.cacheReport({
  //         plants: plantsWithEcoData,
  //         milestones: calculatedMilestones,
  //         wildlife: enrichedWildlife,
  //         tips: tipsData
  //       });

  //       setIsLoading(false);
  //     } catch (err) {
  //       console.error('Error loading eco report data:', err);
  //       setError(err.message || 'Failed to load eco report data');
  //       setIsLoading(false);
  //     }
  //   };

  //   loadReportData();
  // }, []);

  // const handlePrevSection = () => {
  //   if (currentSection > 0) {
  //     setCurrentSection(currentSection - 1);
  //   }
  // };

  // const handleNextSection = () => {
  //   const totalSections = 4 + milestones.length; // cover + intro + milestones + wildlife + tips
  //   if (currentSection < totalSections - 1) {
  //     setCurrentSection(currentSection + 1);
  //   }
  // };

  // const renderCurrentSection = () => {
  //   if (isLoading || plants.length === 0) return null;

  //   // Section 0: Cover
  //   if (currentSection === 0) {
  //     return (
  //       <div className="cover-page">
  //         <div className="cover-content">
  //           <h1 className="cover-title">My Eco Impact</h1>
  //           <p className="cover-subtitle">A Garden Journal</p>
  //           <div className="cover-decoration">🌿</div>
  //           <p className="cover-plants-count">{plants.length} Plants Contributing</p>
  //         </div>
  //       </div>
  //     );
  //   }

  //   // Section 1: Introduction
  //   if (currentSection === 1) {
  //     return (
  //       <>
  //         <div className="section-header">
  //           <div className="eco-section-title">
  //             <div className="section-icon" style={{ backgroundColor: THEME.green }}>
  //               🌿
  //             </div>
  //             <h2>Your Garden's Environmental Impact</h2>
  //           </div>
  //         </div>
  //         <div className="section-body">
  //           <p className="impact-description">
  //             Welcome to your personalised Garden Eco-Report! Discover how your garden is
  //             making a positive impact on the environment. From carbon absorption to
  //             providing habitats for local wildlife, your gardening efforts contribute to
  //             a healthier planet.
  //           </p>
  //           <div className="impact-comparisons">
  //             <div className="comparison-item">
  //               <span className="comparison-icon">🌱</span>
  //               <span>You have {plants.length} plants contributing to environmental health</span>
  //             </div>
  //             <div className="comparison-item">
  //               <span className="comparison-icon">🌍</span>
  //               <span>Total carbon absorbed: {calculateTotalCarbon()} kg CO₂ equivalent</span>
  //             </div>
  //           </div>
  //         </div>
  //       </>
  //     );
  //   }

  //   // Sections 2 to (2 + milestones.length - 1): Milestones
  //   const milestoneIndex = currentSection - 2;
  //   if (milestoneIndex >= 0 && milestoneIndex < milestones.length) {
  //     const milestone = milestones[milestoneIndex];
  //     return (
  //       <>
  //         <div className="section-header" style={{ borderColor: milestone.color }}>
  //           <div className="eco-section-title">
  //             <div className="section-icon" style={{ backgroundColor: milestone.color }}>
  //               {milestone.icon}
  //             </div>
  //             <h2 style={{ color: milestone.color }}>{milestone.title}</h2>
  //           </div>
  //           <div className="section-date">{milestone.date}</div>
  //         </div>
  //         <div className="section-body">
  //           <div className="impact-visualization">
  //             <div className="impact-number" style={{ color: milestone.color }}>
  //               {milestone.visualImpact.value}
  //             </div>
  //             <div className="impact-unit">{milestone.visualImpact.unit}</div>
  //             <div className="progress-container">
  //               <div className="progress-bar" style={{ backgroundColor: milestone.color, width: '100%' }}></div>
  //             </div>
  //           </div>
  //           <p className="impact-description">{milestone.description}</p>
  //           <div className="impact-comparisons">
  //             {milestone.visualImpact.comparisons.map((comparison, idx) => (
  //               <div key={idx} className="comparison-item">
  //                 <span className="comparison-icon">{comparison.icon}</span>
  //                 <span>{comparison.text}</span>
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       </>
  //     );
  //   }

  //   // Section (2 + milestones.length): Wildlife Spotlight
  //   const wildlifeSection = 2 + milestones.length;
  //   if (currentSection === wildlifeSection) {
  //     return (
  //       <>
  //         <div className="section-header">
  //           <div className="eco-section-title">
  //             <div className="section-icon" style={{ backgroundColor: THEME.purple }}>
  //               🦋
  //             </div>
  //             <h2>Wildlife Spotlight</h2>
  //           </div>
  //         </div>
  //         <div className="section-body">
  //           <div className="wildlife-cards">
  //             {wildlifeSpotlight.map((spotlight, index) => (
  //               <div key={index} className="wildlife-card">
  //                 <div className="wildlife-image">
  //                   {spotlight.wikiPageUrl ? (
  //                     <a
  //                       href={spotlight.wikiPageUrl}
  //                       target="_blank"
  //                       rel="noopener noreferrer"
  //                       title={`View ${spotlight.title} on Wikipedia`}
  //                     >
  //                       <img
  //                         src={spotlight.image}
  //                         alt={spotlight.title}
  //                         onError={handleImageError(spotlight)}
  //                       />
  //                     </a>
  //                   ) : (
  //                     <img
  //                       src={spotlight.image}
  //                       alt={spotlight.title}
  //                       onError={handleImageError(spotlight)}
  //                     />
  //                   )}
  //                   <div className="wildlife-icon">{spotlight.icon}</div>
  //                 </div>
  //                 <div className="wildlife-content">
  //                   <h3>{spotlight.title}</h3>
  //                   <p className="scientific-name">{spotlight.scientificName}</p>
  //                   <p style={{ fontSize: '0.9rem', margin: '0 0 8px 0' }}>{spotlight.description}</p>
  //                   <div style={{ fontSize: '0.85rem', color: '#666' }}>
  //                     <div><strong>Behaviour:</strong> {spotlight.behaviors}</div>
  //                     <div style={{ marginTop: '4px' }}><strong>Tip:</strong> {spotlight.encouragementTip}</div>
  //                   </div>
  //                 </div>
  //               </div>
  //             ))}
  //           </div>
  //         </div>
  //       </>
  //     );
  //   }

  //   // Last Section: Environmental Tips
  //   return (
  //     <>
  //       <div className="section-header">
  //         <div className="eco-section-title">
  //           <div className="section-icon" style={{ backgroundColor: THEME.green }}>
  //             🌱
  //           </div>
  //           <h2>Environmental Tips</h2>
  //         </div>
  //       </div>
  //       <div className="section-body">
  //         <div className="tips-container">
  //           {environmentalTips.map(tip => (
  //             <div key={tip.id} className="tip-card">
  //               <div className="tip-number">{tip.id}</div>
  //               <div className="tip-content">
  //                 <h3 style={{ color: THEME.brown, margin: '0 0 5px 0' }}>{tip.tip}</h3>
  //                 <p style={{ margin: '0 0 8px 0', fontSize: '0.9rem', color: '#555' }}>{tip.reason}</p>
  //                 <div style={{ fontSize: '0.85rem' }}>
  //                   <div><strong>How to implement:</strong> {tip.implementation}</div>
  //                   <div style={{ marginTop: '4px' }}><strong>Benefit:</strong> {tip.ecologicalBenefit}</div>
  //                 </div>
  //               </div>
  //             </div>
  //           ))}
  //         </div>
  //       </div>
  //     </>
  //   );
  // };

  // const totalSections = 4 + milestones.length;

  // if (error) {
  //   return (
  //     <div className="garden-eco-report">
  //       <div className="error-container">
  //         <div className="error-message">
  //           ⚠️ {error}
  //         </div>
  //         <button className="retry-button" onClick={() => window.location.reload()}>
  //           Retry
  //         </button>
  //       </div>
  //     </div>
  //   );
  // }

  // if (isLoading) {
  //   return (
  //     <div className="garden-eco-report">
  //       <div className="loader-container">
  //         <EarthLoader />
  //       </div>
  //     </div>
  //   );
  // }

  // if (plants.length === 0) {
  //   return (
  //     <div className="garden-eco-report">
  //       <div className="empty-garden">
  //         <div className="empty-icon">🌱</div>
  //         <h2>No Plants Yet</h2>
  //         <p>Start adding plants to your garden to see your environmental impact!</p>
  //       </div>
  //     </div>
  //   );
  // }

  // return (
  //   <div className="garden-eco-report">
  //     <div className="eco-impact-header">
  //       <h1>My Eco Impact</h1>
  //       <p className="report-dashboard-subtitle">A Garden Journal</p>
  //     </div>

  //     <div className="book-container">
  //       <div className="book-page">
  //         <div className="page-content">
  //           {renderCurrentSection()}
  //         </div>
  //       </div>
  //     </div>

  //     <div className="book-navigation">
  //       <button
  //         className="nav-button"
  //         onClick={handlePrevSection}
  //         disabled={currentSection === 0}
  //       >
  //         ← Previous
  //       </button>

  //       <div className="page-indicator">
  //         Section {currentSection + 1} of {totalSections}
  //       </div>

  //       <button
  //         className="nav-button"
  //         onClick={handleNextSection}
  //         disabled={currentSection === totalSections - 1}
  //       >
  //         Next →
  //       </button>
  //     </div>
  //   </div>
  // );

  return (
    <div className="garden-eco-report">
      {/* <div className="empty-garden"> */}
        {/* <p>Coming soon...</p> */}
        <VirtualBook/>
      {/* </ div> */}
    </div>
    // <VirtualBook />
    
  );
};

export default GardenEcoReport;